export default "__VITE_ASSET__DqjC6YCb__"